@if (dataSource) {
<mat-grid-list
    cols="2"
    rowHeight="399px"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center border-0">
            @if (dataSource) {
            <mat-grid-list
                cols="1"
                rowHeight="120px"
                class="m-w-100"
                gutterSize="19"
            >
                <mat-grid-tile
                    colspan="1"
                    rowspan="1"
                >
                    <div class="bordered-container no-padding justify-center">
                        <div class="wrapper widget-full-width-height-2">
                            @for (item of dataSource.indicatorOptions; track item) {
                            <app-mdr-dashboards-indicator
                                [element]="item"
                                [alterateDataWithValue]="item.title === 'Managed companies' ? -1 : 0"
                            >
                            </app-mdr-dashboards-indicator>
                            }
                        </div>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile
                    colspan="1"
                    rowspan="2.4"
                >
                    <div class="bordered-container">
                        <div class="pie-chart-main">
                            @if (dataSource.licenseStatus.data) {
                            <app-mdr-dashboards-pie-chart
                                [element]="dataSource.licenseStatus"
                                [colors]="dataSource.licenseStatus.colors"
                                [strokeWidth]="4"
                                [donutSize]="'83%'"
                                [width]="150"
                                [height]="190"
                                [tableLegend]="true"
                                [pieWidthCoverage]="'50%'"
                                [legendWidthCoverage]="'30%'"
                                [mainContainerWidth]="'100%'"
                            ></app-mdr-dashboards-pie-chart>
                            }
                        </div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            }
        </div>
    </mat-grid-tile>
    @if (mdrDashboardsService.isLcoCompany(organization)) {
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.recentNotifications"
                [displayedColumns]="dataSource.recentNotifications.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    } @if (!mdrDashboardsService.isLcoCompany(organization)) {
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topInvestigationCategories"
                [mocked]="false"
                [displayedColumns]="dataSource.topInvestigationCategories.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    }
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="263px"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.recentIncidents"
                [displayedColumns]="dataSource.recentIncidents.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<mat-grid-list
    cols="3"
    rowHeight="398px"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.topCustomersWithRecommendations"
                [displayedColumns]="dataSource.topCustomersWithRecommendations.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.topCustomersWithOpenTickets"
                [displayedColumns]="dataSource.topCustomersWithOpenTickets.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [mocked]="false"
                [element]="dataSource.topCustomersWithInvestigations"
                [displayedColumns]="dataSource.topCustomersWithInvestigations.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
}
